import { render } from "./MeasurementList.vue?vue&type=template&id=80b12e12"
import script from "./MeasurementList.vue?vue&type=script&lang=js"
export * from "./MeasurementList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__